import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMathGreaterThan: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMathGreaterThan"><Path d="M5.5 6L18.5 11.5L5.5 17" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMathGreaterThan;
